import { cn } from "#app/utils/misc.tsx";


export default function Container({ className, children }: { className?: string; children: React.ReactNode }) {
    return(
        <div className={cn("max-w-screen-7xl mx-auto px-4 lg:px-6", className)}>
            {children}
        </div>
    )
}